import script from "./TurntableConfigurator.vue?vue&type=script&setup=true&lang=js"
export * from "./TurntableConfigurator.vue?vue&type=script&setup=true&lang=js"

import "./TurntableConfigurator.vue?vue&type=style&index=0&id=46f0bc0d&lang=scss"

export default script